import { BusinessHours } from '../types/shop';

export const hours: BusinessHours = {
  businessHoursMap: {
    Friday: {
      endTime: '22:00',
      id: BigInt(0),
      startTime: '09:00',
      open: true,
    },
    Monday: {
      endTime: '22:00',
      id: BigInt(0),
      startTime: '09:00',
      open: true,
    },
    Saturday: {
      endTime: '22:00',
      id: BigInt(0),
      startTime: '09:00',
      open: true,
    },
    Sunday: {
      endTime: '22:00',
      id: BigInt(0),
      startTime: '09:00',
      open: true,
    },
    Thursday: {
      endTime: '22:00',
      id: BigInt(0),
      startTime: '09:00',
      open: true,
    },
    Tuesday: {
      endTime: '22:00',
      id: BigInt(0),
      startTime: '09:00',
      open: true,
    },
    Wednesday: {
      endTime: '22:00',
      id: BigInt(0),
      startTime: '09:00',
      open: true,
    },
  },
  id: BigInt(0),
  partnerId: BigInt(0),
};
